import React, { useState } from "react";
import IconButton, { IconButtonProps } from "../IconButton";
import { ButtonMenuMenu, MenuItem } from "../ButtonMenu";
import { FC, WithTesting } from "../../types";

export interface IconButtonMenuProps {
  iconButtonProps: IconButtonProps;
  menuItems: MenuItem[];
}

export const IconButtonMenu: FC<IconButtonMenuProps & WithTesting> = (
  props,
) => {
  const { iconButtonProps, menuItems = [], dataTestId } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isOpen = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        {...iconButtonProps}
        isSelected={isOpen}
        data-testid={`icon-button-menu-${dataTestId}`}
        onClick={handleClick}
        title={iconButtonProps.title}
        aria-haspopup="menu"
      />
      <ButtonMenuMenu
        open={isOpen}
        items={menuItems}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        onClose={handleClose}
      />
    </>
  );
};
